import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { NotInterestedIcon } from "@dotnet/telematics-design-system";

import Tag, { TAG_COLORS, TAG_SIZES } from "components/DesignComponents/Tag";
import { TooltipGeneral } from "components/DesignComponents/Tooltips/TooltipGeneral";
import { TOOLTIP_PLACEMENT } from "components/DesignComponents/Tooltips/types/enums";

import { ConfigurationTypeData } from "../types";
import SyncModeWithSelection from "./SyncModeWithSelection";

const SyncMode = ({ data }: ConfigurationTypeData) => {
    const { t } = useTranslation();

    const { featureSettings, hasFeatureFlag, imei, type } = data;

    const renderData = () => {
        // Device is not connected
        if (hasFeatureFlag === null) {
            return "-";
        }

        // NOT SUPPORTED - device does not contain the required feature flag
        if (!hasFeatureFlag) {
            return (
                <TooltipGeneral
                    title={t(
                        "Table details##device details##configuration##mode not supported tooltip"
                    )}
                    placement={TOOLTIP_PLACEMENT.Top}
                >
                    <span css={css({ display: "inline-flex" })}>
                        <Tag
                            size={TAG_SIZES.Medium}
                            color={TAG_COLORS.BasicBundle}
                            iconLeft={<NotInterestedIcon />}
                            title={t(
                                "Table details##device details##configuration##mode titles##not supported"
                            )}
                        />
                    </span>
                </TooltipGeneral>
            );
        }

        // ON/OFF/MONITOR
        return (
            <SyncModeWithSelection
                imei={imei}
                type={type}
                mode={featureSettings}
            />
        );
    };

    return <div>{renderData()}</div>;
};

export default SyncMode;
